import React from 'react';
import { Layout, Seo } from '@layout';
import FindACoupleContainer from '@sections/find-an-event/searchResponse';
import { findACouplePageData } from '@data-ts/pages/find-an-event';

const FindCouple = () => {
  return (
    <Layout
      isTransparentHeader={true}
      transparentJoyLogoColor="newPurple5"
      transparentHeaderButtonVariant="primary"
      transparentHeaderLinkVariant="navLink"
      page="find"
    >
      <Seo title={findACouplePageData.seo.title} description={findACouplePageData.seo.content} canonicalURL={findACouplePageData.seo.url} />
      <FindACoupleContainer />
    </Layout>
  );
};

export default FindCouple;
